import { useEffect, useRef, useState } from 'react'

export default function PrefetchLink({
  href,
  children,
  isActive = false,
  className = '',
  enablePrefetch = true,
  ...props
}: {
  href: string
  children?: string
  isActive?: boolean
  className?: string
  enablePrefetch?: boolean
}) {
  const [isPrefetched, setIsPrefetched] = useState(false)
  const linkRef = useRef<HTMLLinkElement | null>(null)

  useEffect(() => {
    return () => {
      if (linkRef.current) {
        linkRef.current.remove()
        linkRef.current = null
      }
    }
  }, [href])

  const handlePrefetch = () => {
    if (!enablePrefetch || isPrefetched || isActive) return

    if (linkRef.current) {
      linkRef.current.remove()
    }

    const link = document.createElement('link')
    link.rel = 'prefetch'
    link.href = href
    document.head.appendChild(link)

    linkRef.current = link
    setIsPrefetched(true)
  }

  return (
    <a
      href={href}
      className={className}
      onMouseEnter={handlePrefetch}
      onTouchStart={handlePrefetch}
      onFocus={handlePrefetch}
      {...props}
    >
      {children}
    </a>
  )
}
